// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__v+ZAh","active":"Pagination_active__q3h4d","page":"Pagination_page__fm3g4","btn":"Pagination_btn__RGopE"};